import { Component, OnDestroy, OnInit, Input, ViewContainerRef, } from '@angular/core';
// import { CorporateMembers } from './../../api/corporate-members';
import { MysqlService } from './../../services/mysql.service';
import { SearchService,  } from './../../services/search.service';

import { Meta, Title } from '@angular/platform-browser';
import {NgxPaginationModule} from 'ngx-pagination'; // <-- import the module
// import { AuthService } from '../../auth/auth.service';

import { FormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
// import { FilterPipe } from './../../../filters/filter.pipe';


import {platformBrowserDynamic} from '@angular/platform-browser-dynamic';

import {ReactiveFormsModule, FormControl} from '@angular/forms';
import {Observable} from 'rxjs';

import { ActivatedRoute, Router } from '@angular/router';
import { DemoService } from './../../demo.service';
import { HotToastService } from '@ngneat/hot-toast';
import { GlobalFunctionsService } from './../../services/global-functions.service';
import { Brand } from './../../shared/models/brand.model';
import { DatePipe } from '@angular/common';
import { environment } from './../../../environments/environment';



@Component({
  selector: 'app-client-dashboard',
  templateUrl: './client-dashboard.component.html',
  styleUrls: ['./client-dashboard.component.css']
})
export class ClientDashboardComponent implements OnInit {



  sessionBrandId: any;
  sessionUsername: any;
  sessionUserId: any;
  currentUserVAR: any;
  clientBrandsCount: any;
  brandUsersCount: any;
  brandUsers: any;
  clientBrands: any;
  brandsMysql: any;

  // public brand_id: number;
  @Input() brand_id: number; // allows for module to be included in another template.

  div: any;
  public nav: any;
  public body: any;
  public container: any;
  brandMysql: Brand[];




  // nav: any;
  // body: HTMLBodyElement;
  // currentUserVAR: any;
  // sessionUserId: any;
  // sessionUsername: any;
  // sessionBrandId: any;
  // sessionUserLevel: any;
  // brand_id: any;

  public sparklineData:Array<any> = [34, 43, 43, 35, 44, 32, 44, 52];
  public sparklineData2:Array<any> = [32, 11, 25, 37, 41, 32, 34, 42];
  public sparklineOptions:any = {type: 'line', width: '100%', height: '50', lineColor: '#1ab394', fillColor: "transparent"};

  public peityType1:string = "bar";
  public peityType2:string = "line";
  public peityOptions1:any = { fill: ["#1ab394", "#d7d7d7"], width:100};
  public peityOptions2:any = { fill: ["#1ab394", "#d7d7d7"]};
  public peityOptions3:any = { fill: '#1ab394', stroke:'#169c81'};
  all_router_details: string;

  
  // Statistics (set at the time of the sql/api call on the template or oninit..)
      currentPL: any;
      pl_count: number;
      l_count: number;
      nl_count: number;
      l_percent: number;
      nl_percent: number;
      pl_percent: number;
      total_open: number;
      total_all: number; // => this is all completed
      total_all_all: number; // => this is all candidtes in total
      current_trace_type_id: number; // => this is set when the trace is called
      trace_type_fee: number; // => created a new call/subscription to get this figure.
      total_fee: number;

      pl_count_total: number;
      total_traces: any;
      calc_adverage_time_taken: number;
      adverage_time_taken: number;
      total_time_taken: any;
      l_count_total: any;


  //    API RESULTS
      subjectsAllAll: any;
      subjectsAllOpen: any;
      subjectsAll: any;
      subjectsNL: any;
      subjectsPL: any;
      subjectsL: any;


  // tslint:disable-next-line:max-line-length
  // Charts

  
  // tslint:disable-next-line:max-line-length
  options: { barColor: string; trackColor: string; scaleColor: string; scaleLength: number; lineCap: string; lineWidth: number; size: number; rotate: number; animate: { duration: number; enabled: boolean; }; };
  percent: number;
  

  public baseUploadURL = environment.php_apiURL + '/uploads/test_area'; // no trailing slash

  constructor(
    private _mysqlService: MysqlService, public itunes: SearchService, public member: SearchService,
    private route: ActivatedRoute, private router: Router,
   public _demoService: DemoService,
   public toastr: HotToastService,
   vcr: ViewContainerRef,
   public gfunc: GlobalFunctionsService,
   public datepipe: DatePipe,
  ) {


   

    this.nav = document.querySelector('nav.navbar');
    this.body = document.querySelector('body');

// Set and Access login Session Variables
this.gfunc.setLoginSessionVars(); // set in a global function file
this.sessionUserId = this.gfunc.currentUserVAR.user_id;
this.sessionUsername = this.gfunc.currentUserVAR.username;
this.sessionBrandId = this.gfunc.currentUserVAR.brand_id;

// need to add this as routes does not work globally
this.all_router_details = this.router.url;
this.gfunc.current_base_route = this.router.url.substr(0, this.all_router_details.lastIndexOf('/'));
    this.nav = document.querySelector('nav.navbar');
    // this.body = document.querySelector('body');
   
   // this.brand_id = +this.route.snapshot.paramMap.get('brand_id');

   this.brand_id = this.sessionBrandId; // set to logged in user


   }

  ngOnInit() {
    this.nav.className += ' white-bg';

    // this.getBrandMysql(this.brand_id);
    // // Main Graphs - Traces by Brand
    // this.getTracesByBrandL(this.brand_id);
    // this.getTracesByBrandAll(this.brand_id);
    // this.getClientBrands(this.brand_id);
    // this.getBrandUsers(this.brand_id);

        // percentages


console.log('Inside:L%: ' + this.total_all_all);

// pie chart in the constructor
this.percent = 45;

this.options = {
  barColor: '#1ab394',
  trackColor: '#f9f9f9',
  scaleColor: '#dfe0e0',
  scaleLength: 15,
  lineCap: 'round',
  lineWidth: 12,
  size: 170,
  rotate: 0,
  animate: {
      duration: 2000,
      enabled: true
  }
};

  }

// the sql magic

private getBrandMysql(brand_id) {
  this._mysqlService.getMysqlBrandDatas(brand_id)
    .subscribe(
      res => this.brandMysql = res,
      err => console.error(err.status)
    );
}


getBrandsMysql() {
  this._mysqlService.getMysqlBrandsDatas()
    .subscribe(
      res => this.brandsMysql = res,
      err => console.error(err.status)
    );
}


// API
getTracesByBrandL(brand_id) {
this._demoService.getTracesByBrandL(brand_id)
  .subscribe(
    data => { this.subjectsL = data;
   // this.l_count = this.subjectsL.length;
   // this.l_percent = (this.l_count / this.total_all ) * 100;
    },
    err => console.error(err),
   //  () =>  console.log('loading L')
  );
}


getClientBrands(brand_id) {
this._demoService.getClientBrands(brand_id)
  .subscribe(
    data => { this.clientBrands = data;
   this.clientBrandsCount = this.clientBrands.length;
   // this.l_percent = (this.l_count / this.total_all ) * 100;
    },
    err => console.error(err),
   //  () =>  console.log('loading L')
  );
}


getBrandUsers(brand_id) {
this._demoService.getBrandUsers(brand_id)
  .subscribe(
    data => { this.brandUsers = data;
    this.brandUsersCount = this.brandUsers.length;
    },
    err => console.error(err),
   //  () =>  console.log('loading L')
  );
}


getTracesByBrandAll(brand_id) {
this._demoService.getTracesByBrandAll(brand_id)
  .subscribe(
    data => { this.subjectsAll = data;
   
      this.total_traces = this.subjectsAll.length;
   
   
   
      // this.total_all = this.subjectsAll.length;
    // Try to 'reduce' json data string and do the sums
    // This function adds up all the items in the column
this.total_all = this.subjectsAll.filter((item) => item.total_all)
      .map((item) => +item.total_all)
      .reduce((sum, current) => sum + current);

      // Try to 'reduce' json data string and do the sums
// This function adds up all the items in the column

this.l_count = this.subjectsAll.filter((item) => item.l_count)
        .map((item) => +item.l_count)
        .reduce((sum, current) => sum + current);
        // console.log(this.l_count_total);


      this.pl_count = this.subjectsAll.filter((item) => item.pl_count)
      .map((item) => +item.pl_count)
      .reduce((sum, current) => sum + current);

      this.nl_count = this.subjectsAll.filter((item) => item.nl_count)
      .map((item) => +item.nl_count)
      .reduce((sum, current) => sum + current);

      this.total_open = this.subjectsAll.filter((item) => item.total_open)
      .map((item) => +item.total_open)
      .reduce((sum, current) => sum + current);

      this.total_all_all = this.subjectsAll.filter((item) => item.total_all_all)
      .map((item) => +item.total_all_all)
      .reduce((sum, current) => sum + current);

      this.total_fee = this.subjectsAll.filter((item) => item.fee)
      .map((item) => +item.fee)
      .reduce((sum, current) => sum + current);

      this.total_time_taken = this.subjectsAll.filter((item) => item.time_taken)
      .map((item) => +item.time_taken)
      .reduce((sum, current) => sum + current);

      this.adverage_time_taken = (this.total_time_taken / this.total_all );
      this.calc_adverage_time_taken =  (this.adverage_time_taken / 3600 ) / 24;

      // percentages
      this.l_percent = (this.l_count / this.total_all) * 100;
      this.pl_percent = (this.pl_count / this.total_all) * 100;
      this.nl_percent = (this.nl_count / this.total_all) * 100;

      console.log('this.total_all ' + this.total_all);
      console.log('L%: ' + this.l_percent);

    },
    err => console.error(err),
   //  () =>  console.log('loading L')
  );
}



}

